import React, { useMemo } from 'react'

import { Box } from '@usap/uicomponents'

import RemoveAndProceedToCheckout from './RemoveAndProceedToCheckout'
import RemoveAndContinueShopping from './RemoveAndContinueShopping'
import Notify from './Notify'

const Actions = params => {
  const { data } = params

  const pad = useMemo(
    () => ({ vertical: 'small' }),
    [],
  )

  const flex = useMemo(() => ({ grow: 0, shrink: 0, basis: '200px' }), [])

  return (
    <Box pad="small" flex={flex}>
      <Box pad={pad}>
        <RemoveAndProceedToCheckout data={data} />
      </Box>
      <Box pad={pad}>
        <RemoveAndContinueShopping data={data} />
      </Box>
      <Box pad={pad}>
        <Notify data={data} />
      </Box>
    </Box>
  )
}

export default Actions
